const STABLE_FAILURE_CLASSES = new Set([
  "CHAIN_DATA_UNAVAILABLE",
  "INVALID_TRANSFER_AMOUNT",
  "MEMBER_WALLET_LINK_REQUIRED",
  "TX_HASH_MISSING",
  "WALLET_CONTINUITY_MISMATCH",
]);

export function diagnosticFailureClass(error: unknown): string {
  if (!(error instanceof Error)) return "NON_ERROR_THROWN";
  if (STABLE_FAILURE_CLASSES.has(error.message)) return error.message;
  if (error instanceof TypeError) return "TYPE_ERROR";
  if (typeof DOMException !== "undefined" && error instanceof DOMException) {
    return "DOM_EXCEPTION";
  }
  return "ERROR";
}
